<div
    ngbAccordion
    [closeOthers]="true"
    class="ngb-accordion-with-icon"
    data-testid="t-conditions-div-1752672977568-19"
>
    <div
        ngbAccordionItem
        [disabled]="!updateable()"
        data-testid="t-conditions-div-1752672977568-18"
    >
        <div
            ngbAccordionHeader
            data-testid="t-conditions-div-1752672977568-2"
        >
            <button
                ngbAccordionButton
                data-testid="t-conditions-button-1752672977568-1"
            >
                @if (costcenter) {
                    <span
                        class="card-header-text"
                        data-testid="t-conditions-span-1752672977568-1"
                    >
                        {{ costcenter.description }}
                        ({{ costcenter.costcenterNumber }})
                    </span>
                }
                @if (scc().supplierContractCostcenterCustomers && scc().supplierContractCostcenterCustomers.length > 0) {
                    <div
                        style="right: 50px; position: absolute; color: green"
                        data-testid="t-conditions-div-1752672977568-1"
                    >
                        <i
                            class="oc-general-check text-tiny"
                            data-testid="t-conditions-i-1752672977568-1"
                        ></i>
                    </div>
                }
            </button>
        </div>

        <div
            ngbAccordionCollapse
            data-testid="t-conditions-div-1752672977568-17"
        >
            <div
                ngbAccordionBody
                data-testid="t-conditions-div-1752672977568-16"
            >
                <ng-template>
                    <div
                        class="form-elements--wrapper"
                        data-testid="t-conditions-div-1752672977568-3"
                    >
                        <!-- Kostenstellenbezogenen Lieferadressen ADDRESSES -->
                        <app-addresses
                            [privilegeContext]="'supplier.contract.costcenter'"
                            [isModal]="false"
                            [title]="costcenterAddressTitle"
                            [updateable]="false"
                            [addresses]="ccAddresses"
                            data-testid="t-conditions-app-addresses-1752672977568-1"
                        ></app-addresses>
                    </div>

                    <div
                        class="form-elements--wrapper"
                        data-testid="t-conditions-div-1752672977568-15"
                    >
                        <div
                            class="add--header"
                            data-testid="t-conditions-div-1752672977568-6"
                        >
                            <div
                                class="col"
                                data-testid="t-conditions-div-1752672977568-4"
                            >
                                <span
                                    class="h5"
                                    data-testid="t-conditions-span-1752672977568-2"
                                    >{{ 'mws.customers' | i18n }}:</span
                                >
                            </div>
                            <div
                                class="col-auto text-end"
                                data-testid="t-conditions-div-1752672977568-5"
                            >
                                @if (updateable()) {
                                    <a
                                        class="btn btn-primary action--btn btn-sm"
                                        ocPreventDoubleClick
                                        (throttledClick)="openCustomerModal()"
                                        [attr.aria-label]="'mws.addresstype' | i18n"
                                        data-testid="t-conditions-a-1752672977568-1"
                                    >
                                        <i
                                            class="oc-plus"
                                            data-testid="t-conditions-i-1752672977568-2"
                                        ></i>
                                    </a>
                                }
                                &nbsp;
                            </div>
                        </div>

                        <!-- KUNDEN -->
                        @for (sccc of scc().supplierContractCostcenterCustomers; track sccc) {
                            <div data-testid="t-conditions-div-1752672977568-14">
                                <div
                                    ngbAccordion
                                    [closeOthers]="true"
                                    class="ngb-accordion-with-icon"
                                    data-testid="t-conditions-div-1752672977568-13"
                                >
                                    <div
                                        ngbAccordionItem
                                        data-testid="t-conditions-div-1752672977568-12"
                                    >
                                        <div
                                            ngbAccordionHeader
                                            data-testid="t-conditions-div-1752672977568-9"
                                        >
                                            <button
                                                ngbAccordionButton
                                                data-testid="t-conditions-button-1752672977568-2"
                                            >
                                                <span
                                                    class="card-header-text"
                                                    data-testid="t-conditions-span-1752672977568-3"
                                                    >{{ sccc.supplierCustomer.customerName }}</span
                                                >
                                                @if (sccc.isFavorite === true) {
                                                    <div
                                                        style="right: 50px; position: absolute"
                                                        data-testid="t-conditions-div-1752672977568-7"
                                                    >
                                                        <i
                                                            class="d-inline-block oc-heart-filled text-white"
                                                            [ngbTooltip]="'mws.favorite' | i18n"
                                                            data-testid="t-conditions-i-1752672977568-3"
                                                        ></i>
                                                    </div>
                                                }
                                                <div
                                                    class="collapse-icon"
                                                    data-testid="t-conditions-div-1752672977568-8"
                                                ></div>
                                            </button>
                                        </div>
                                        <div
                                            ngbAccordionCollapse
                                            data-testid="t-conditions-div-1752672977568-11"
                                        >
                                            <div
                                                ngbAccordionBody
                                                data-testid="t-conditions-div-1752672977568-10"
                                            >
                                                <ng-template>
                                                    <app-deliveryterms
                                                        [supplierContractCostcenterCustomer]="sccc"
                                                        [indexSupplierContractCostcenters]="indexSupplierContractCostcenters()"
                                                        [costcenterAddresses]="ccAddresses"
                                                        data-testid="t-conditions-app-deliveryterms-1752672977568-1"
                                                    />
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<ng-template
    #customerModal
    let-c="close"
    let-d="dismiss"
>
    <!--    (ngSubmit)="submit(supplierContactForm)"-->
    <form
        [formGroup]="customerForm"
        class="customer-form"
        novalidate
        data-testid="t-conditions-form-1752672977568-1"
    >
        <div
            class="modal-header"
            data-testid="t-conditions-div-1752672977568-20"
        >
            <button
                type="button"
                id="customer-cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                ocPreventDoubleClick
                (throttledClick)="d('Close click')"
                data-testid="t-conditions-button-1752672977568-3"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-conditions-i-1752672977568-4"
                ></i>
            </button>
            <span
                class="h5 modal-title"
                data-testid="t-conditions-span-1752672977568-4"
                >{{ 'mws.addcustomer' | i18n }}</span
            >
        </div>

        <div
            class="modal-body"
            data-testid="t-conditions-div-1752672977568-28"
        >
            <div
                class="form-group"
                data-testid="t-conditions-div-1752672977568-22"
            >
                <div
                    class="select-wrapper"
                    data-testid="t-conditions-div-1752672977568-21"
                >
                    <label
                        class="form-label"
                        data-testid="t-conditions-label-1752672977568-1"
                        >{{ 'mws.chooseexistingcustomerornewcustomer' | i18n }}:</label
                    >
                    <select
                        formControlName="customerId"
                        class="form-select"
                        (ngModelChange)="changeCustomerSelectBox()"
                        data-testid="t-conditions-select-1752672977568-1"
                    >
                        <option
                            value="0"
                            data-testid="t-conditions-option-1752672977568-1"
                        >
                            {{ 'mws.newcustomer' | i18n }}
                        </option>
                        @for (suppCust of supplierCustomersFiltered; track suppCust) {
                            <option
                                [ngValue]="suppCust.id"
                                data-testid="t-conditions-option-1752672977568-2"
                            >
                                {{ suppCust.customerNumber }} - {{ suppCust.customerName }}
                            </option>
                        }
                    </select>
                </div>
            </div>

            <div
                class="form-elements--wrapper mt-3"
                data-testid="t-conditions-div-1752672977568-27"
            >
                <div
                    class="edit--language"
                    data-testid="t-conditions-div-1752672977568-26"
                >
                    <div
                        class="form-group"
                        data-testid="t-conditions-div-1752672977568-23"
                    >
                        <oc-label
                            [forElement]="'customerNumber'"
                            [schema]="'supplierCustomer'"
                            [propertyName]="'customerNumber'"
                            [value]="'mws.customernumber' | i18n"
                            [classes]="'form-label'"
                            data-testid="t-conditions-oc-label-1752672977568-1"
                        ></oc-label>
                        <input
                            type="text"
                            class="form-control"
                            #customerNumber
                            id="customerNumber"
                            formControlName="customerNumber"
                            placeholder="{{ 'mws.customernumber' | i18n }}"
                            data-testid="t-conditions-input-1752672977568-1"
                        />
                        <oc-validator-error
                            [control]="customerf.customerNumber"
                            [propertyName]="'customerNumber'"
                            [inputElementId]="'customerNumber'"
                            data-testid="t-conditions-oc-validator-error-1752672977568-1"
                        ></oc-validator-error>
                    </div>
                    <!--                            <div *ngIf="customerf.customerNumber.errors">-->
                    <!--                                <div *ngFor="let e of customerf.customerNumber.errors?.jsonSchemaError?.errors"-->
                    <!--                                     class="alert alert-danger">-->
                    <!--                                    {{e.message}}-->
                    <!--                                </div>-->
                    <!--                            </div>-->

                    <div
                        class="form-group"
                        data-testid="t-conditions-div-1752672977568-24"
                    >
                        <oc-label
                            [forElement]="'customerName'"
                            [schema]="'supplierCustomer'"
                            [propertyName]="'customerName'"
                            [value]="'mws.customername' | i18n"
                            [classes]="'form-label'"
                            data-testid="t-conditions-oc-label-1752672977568-2"
                        ></oc-label>
                        <input
                            type="text"
                            class="form-control"
                            #customerName
                            id="customerName"
                            formControlName="customerName"
                            [placeholder]="'mws.customername' | i18n"
                            data-testid="t-conditions-input-1752672977568-2"
                        />

                        <oc-validator-error
                            [control]="customerf.customerName"
                            [propertyName]="'customerName'"
                            [inputElementId]="'customerName'"
                            data-testid="t-conditions-oc-validator-error-1752672977568-2"
                        ></oc-validator-error>
                    </div>

                    <div
                        class="form-group"
                        data-testid="t-conditions-div-1752672977568-25"
                    >
                        <label
                            class="form-label"
                            data-testid="t-conditions-label-1752672977568-2"
                            >{{ 'mws.currencyoninvoice' | i18n }}:</label
                        >
                        <select
                            class="form-select"
                            formControlName="currencyId"
                            data-testid="t-conditions-select-1752672977568-2"
                        >
                            @for (cur of environmentService.currencyList; track cur) {
                                <option
                                    [ngValue]="cur.id"
                                    data-testid="t-conditions-option-1752672977568-3"
                                >
                                    {{ cur.descr }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal-footer"
            data-testid="t-conditions-div-1752672977568-30"
        >
            <div
                class="button-wrapper"
                data-testid="t-conditions-div-1752672977568-29"
            >
                <button
                    type="button"
                    id="customer-success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    [disabled]="!customerForm.get('changed').touched"
                    ocPreventDoubleClick
                    (throttledClick)="addCustomer(); c('Close click')"
                    data-testid="t-conditions-button-1752672977568-4"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-conditions-i-1752672977568-5"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</ng-template>
